export enum FILTER_TYPES {
  DATE = 'date',
  SELECT = 'select',
  STRING = 'string'
}
